import capitalize from "lodash/capitalize"
export default {
  indexToNamespace: function (index) {
    if (index.match(/g[0-9]+_companies/)) {
      return "Companies"
    }
    return capitalize(index)
  },
}
